import { ForgetPasswordScreenNavigationProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import ForgetPassword from "./forget-password-screen"
import { PageRoot } from "~screens/page-root"


const ForgetPasswordScreen: React.FC<ForgetPasswordScreenNavigationProps> = () => {
  const theme = useTheme()
  return (
    <PageRoot $background={theme.colors.primary}>
      <ForgetPassword />
    </PageRoot>
  )
}

export default ForgetPasswordScreen
